/** Display headline for location cards / header when CMS `name` should read differently. */
export const LOCATION_SHORT_NAMES: Record<string, string> = {
  "5th Avenue": "New York City"
}

const LOCATION_CARD_SUBHEADERS: Record<string, string> = {
  "New York City": "Flatiron District",
  "5th Avenue": "Flatiron District"
}

export function getLocationCardHeadline(
  name: string | null | undefined
): string {
  if (!name) return "USA"
  return LOCATION_SHORT_NAMES[name] ?? name
}

export function getLocationCardSubline(
  name: string | null | undefined,
  city: string | null | undefined
): { text: string; uppercase: boolean } | null {
  const override = name ? LOCATION_CARD_SUBHEADERS[name] : undefined
  if (override) return { text: override, uppercase: true }
  if (city) return { text: city, uppercase: true }
  return null
}

const LOCATION_SLUG_ALIASES: Record<string, string> = {
  "new-york-city": "fifth-ave-nyc"
}

export const resolveLocationSlugAlias = (slug: string): string =>
  LOCATION_SLUG_ALIASES[slug] ?? slug

const LOCATION_ROUTE_SLUGS: Record<string, string> = {
  "fifth-ave-nyc": "new-york-city"
}

export const resolveLocationRouteSlug = (slug: string): string =>
  LOCATION_ROUTE_SLUGS[slug] ?? slug

/** Local logos with a white outer border for contrast on the primary header bar. */
const HEADER_LOCATION_LOGO_URLS: Record<string, string> = {
  Charlotte: "/images/header-location-logos/charlotte.png",
  Houston: "/images/header-location-logos/houston.png",
  Miami: "/images/header-location-logos/miami.png",
  Minneapolis: "/images/header-location-logos/minneapolis.png"
}

export const getHeaderLocationLogoUrl = (
  locationName: string | null | undefined
): string | null =>
  locationName ? (HEADER_LOCATION_LOGO_URLS[locationName] ?? null) : null
